import React, { useEffect, useState } from 'react';
import { Input, Textarea } from './../../components/forms/input';
import axios from 'axios';
import Head from 'next/head';

const NewYear2023 = props => {
  const [step, setStep] = useState(1);
  const [index, setIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showGift, setShowGift] = useState(true);
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const [data, setData] = useState({});
  const [imgUrl, setImgUrl] = useState('');
  const [exists, setExists] = useState({});
  const [isWinner, setIsWinner] = useState(false);

  const gifs = [
    'https://i.giphy.com/media/bNpLfNOskgvGIfKIZN/giphy.webp',
    'https://i.giphy.com/media/UoS3N8Hv1kyKF3IrEA/giphy.webp',
    'https://i.giphy.com/media/PlbDI5gaNCtISSIpz3/giphy.webp',
    'https://i.giphy.com/media/MKzU3oPvBjFV4DC36t/giphy.webp',
    'https://i.giphy.com/media/Jt4sQOFEh29Ob8KAxg/giphy.webp',
    'https://i.giphy.com/media/cIyFkXsHAkmA6vwNgj/giphy.webp',
    'https://i.giphy.com/media/MdpSuAccvSeR3VjUrS/giphy.webp',
    'https://i.giphy.com/media/1xop07vDnHKJt85MyF/giphy.webp',
    'https://i.giphy.com/media/gzRiZROEyDCznPofKj/giphy.webp',
    'https://i.giphy.com/media/26xBKqeFFspRZjDTW/giphy.webp',
    'https://i.giphy.com/media/7XmgreV9azxTwAkjO4/giphy.webp',
    'https://i.giphy.com/media/USE5vWQyWQvHxVmNIb/giphy.webp',
    'https://i.giphy.com/media/nZJYTigoPVyefVSL1k/giphy.webp',
    'https://i.giphy.com/media/xThtavV3Ds2631gcWk/giphy.webp',
    'https://i.giphy.com/media/qHEEUUd0TWdos/giphy.webp',
    'https://i.giphy.com/media/QyJ0We4GHpjBa7PvKL/giphy.webp',
    'https://i.giphy.com/media/J53Wp5Y8Lv4U5jueCr/giphy.webp',
    'https://i.giphy.com/media/XgGClig7fzKpHYwwlL/giphy.webp',
  ];
  const validEmails = [
    'arusik.rostomyan@prodigi.am',
    'anahit.chaghlasyan@prodigi.am',
    'maria@prodigi.am',
    'mariam.babayan@prodigi.am',
    'valera@prodigi.am',
    'hermine@prodigi.am',
    'karen.kamalyan@prodigi.am',
    'ani.hakobyan@prodigi.am',
    'anahit.v@prodigi.am',
    'anahit.k@prodigi.am',
    'anna@prodigi.am',
    'arpy.zakaryan@prodigi.am',
    'anush.gasparyan@prodigi.am',
    'lilit@prodigi.am',
    'lilit.avalyan@prodigi.am',
    'mariam.stepanyan@prodigi.am',
    'siranush@prodigi.am',
    'mary.knyazyan@prodigi.am',
    'anna.hovhannisyan@prodigi.am',
    'taguhi@prodigi.am',
    'inga@weprodigi.com',
    'anna@weprodigi.com',
    'angela@weprodigi.com',
    'daniel@prodigi.am',
    'christine.mkhitaryan@prodigi.am',
    'meline@prodigi.am',
    'anna.baghdikyan@prodigi.am',
    'nare@weprodigi.com',
    'lilit.sukiasyan@prodigi.am',
    'marine.zakaryan@prodigi.am',
    'elina.trdatyan@prodigi.am',
    'marlena@nativenetwork.uz',
    'aida@weprodigi.com',
  ];
  const randomIntFromInterval = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
  };
  const checkValid = inputText => {
    if (inputText && inputText.split('@').length > 1) {
      let domain = inputText.split('@')[1];
      if ((domain == 'prodigi.am' || domain == 'weprodigi.com') && validEmails.includes(email)) {
        axios.get('https://admin.weprodigi.com/api/get-gift-info?email=' + email + '&index=' + index).then(res => {
          setIsWinner(false);
          setData(res.data.dayInfo);
          if (res.data.dayInfo.wining_email == email) {
            setIsWinner(true);
            setError(false);
            setStep(2);
            setExists(false);
            // setShowGift(false)
          } else if (res.data.exists) {
            setError("That's enough for today. Let's try tomorrow.");
            setExists(true);
            setStep(2);
            // setShowGift(false)
          } else {
            setExists(false);
            setError(false);
            setStep(2);
          }
        });
      } else {
        setError("Please enter the company's valid email");
      }
    } else {
      setError("Please enter the company's valid email");
    }
  };
  const getGift = () => {
    if (isWinner) {
      let giftsArray = data.gift.split(',');
      setIndex(randomIntFromInterval(0, giftsArray.length));
      setImgUrl(giftsArray[index]);
    } else {
      let ind = randomIntFromInterval(0, gifs.length - 2);
      setImgUrl(gifs[ind]);
    }
    setShowGift(false);
  };
  const [myPriceAudio, setMyPriceAudio] = useState(null);
  useEffect(() => {
    setMyPriceAudio(new Audio('https://weprodigi.com/uploads/images/new-year-2023/Michael_Buble_-_Holly_Jolly_Christmas.mp3'));

    if (myPriceAudio) {
      myPriceAudio.addEventListener(
        'ended',
        function () {
          this.currentTime = 0;
          this.play();
        },
        false
      );
    }
  }, []);

  return (
    <>
      <Head>
        <title>Lucky Prodigist</title>
        <meta name="description" content="Let's Play the game" />

        <meta httpEquiv="ScreenOrientation" content="autoRotate:disabled" />
        <meta property="og:url" content="https://weprodigi.com/lucky-prodigist" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Lucky Prodigist" />
        <meta property="og:description" content="Let's Play the game" />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/new-year-2023/BG-for-step-1.png" />
      </Head>
      <style>{`
            *{
                overflow:hidden;
            }
           
           .form-group{
            width:100%
           }
            .bg-image-for-landing{
                background-image:url("https://weprodigi.com/uploads/images/new-year-2023/BG-for-step-1.png");
               animation: changeBg 1s infinite;
                overflow:hidden;
            }
            .tree-1{  
                animation: scale1 8s infinite;
            }
             .tree-2{  
                animation: scale1 8s infinite;
                animation-delay:1s
            }
            .tree-3{  
                animation: scale1 7s infinite;
            }
             .tree-4{  
                animation: scale1 8s infinite;
                animation-delay:0.1s
            }
           @keyframes changeBg{
               0%,100%  {background-image: url("https://weprodigi.com/uploads/images/new-year-2023/BG-for-step-1.png");}
               25% {background-image: url("https://weprodigi.com/uploads/images/new-year-2023/BG-step-1-with-light.png");}
               50% {background-image: url("https://weprodigi.com/uploads/images/new-year-2023/BG-for-step-1.png");}
               75% {background-image: url("https://weprodigi.com/uploads/images/new-year-2023/BG-step-1-with-light.png");}
            }
            @keyframes scale1{
               0%,100%  {transform:scale(1)}
               25% {transform:scale(1.01)}
               50% {transform:scale(1)}
               75% {transform:scale(1.01)}
            }
            .bg-image-for-landing::before {
              content: "";
              position:absolute;
              top:0;
              left:0;
              width:100%;
              height:100%;
              background:url("https://weprodigi.com/uploads/images/new-year-2023/overlay-1.png")
            }
            .bg-image-for-landing.page-2::before {
              content: "";
              position:absolute;
              top:0;
              left:0;
              width:100%;
              height:100%;
              background:url("https://weprodigi.com/uploads/images/new-year-2023/blured.png")
            }
            .start-button{
                  outline: 15px solid rgba(255, 255, 255, .15);
                  width:400px;
                  height:400px;
                    -webkit-border-radius: 50%;
                    -moz-border-radius: 50%;
                    border-radius: 50%;
                    -khtml-border-radius: 50%;
                  background:url(https://weprodigi.com/uploads/images/new-year-2023/bg.png);
                  background-size:cover;
                  font-size: 86px;
                  text-transform: uppercase;
                  color: #ffffff;
                  font-family:DKMagicalBrush;
                  margin-top:120px
            }
            .start-button:hover{
                transform:scale(1.01);
                transition:all 0.3s;
            }
             .gift:hover{
                transform:scale(1.01);
                transition:all 0.3s;
            }
            a.texts-link img{
                filter: brightness(0) invert(1);
            }
            .texts p{
                font-size:120px;
                color:white;
                z-index:300;
                position:absolute;
                font-family:DKMagicalBrush;
                text-transform:uppercase;
                line-height:100px;
                left:0
            }
            
            .texts-2 p{
                font-size:105px;
                color:white;
                z-index:300;
                position:relative;
                font-family:DKMagicalBrush;
                text-transform:uppercase;
                line-height:100px;
                left:0
            }
            .rotate{
                transform:rotate(8deg);
                top:160px
            }
            .rotate-2{
                transform:rotate(5deg);
                margin-top:30px
             }
            .transform-center{
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index:600;
              background: rgba(103, 15, 122, 0.69);
            }  
            
            .scale{
                -webkit-animation: scale 16s cubic-bezier(0.230, 1.000, 0.320, 1.000) both infinite;
                        animation: scale 1.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both infinite;
            }
            .jello-horizontal {
                -webkit-animation: jello-horizontal 1.9s both infinite;
                        animation: jello-horizontal 1.9s both infinite;
                }
                @-webkit-keyframes jello-horizontal {
                  0% {
                    -webkit-transform: scale3d(1, 1, 1);
                            transform: scale3d(1, 1, 1);
                  }
                  30% {
                    -webkit-transform: scale3d(1.25, 0.75, 1);
                            transform: scale3d(1.25, 0.75, 1);
                  }
                  40% {
                    -webkit-transform: scale3d(0.75, 1.25, 1);
                            transform: scale3d(0.75, 1.25, 1);
                  }
                  50% {
                    -webkit-transform: scale3d(1.15, 0.85, 1);
                            transform: scale3d(1.15, 0.85, 1);
                  }
                  65% {
                    -webkit-transform: scale3d(0.95, 1.05, 1);
                            transform: scale3d(0.95, 1.05, 1);
                  }
                  75% {
                    -webkit-transform: scale3d(1.05, 0.95, 1);
                            transform: scale3d(1.05, 0.95, 1);
                  }
                  100% {
                    -webkit-transform: scale3d(1, 1, 1);
                            transform: scale3d(1, 1, 1);
                  }
                }
                @keyframes jello-horizontal {
                  0% {
                    -webkit-transform: scale3d(1, 1, 1);
                            transform: scale3d(1, 1, 1);
                  }
                  30% {
                    -webkit-transform: scale3d(1.25, 0.75, 1);
                            transform: scale3d(1.25, 0.75, 1);
                  }
                  40% {
                    -webkit-transform: scale3d(0.75, 1.25, 1);
                            transform: scale3d(0.75, 1.25, 1);
                  }
                  50% {
                    -webkit-transform: scale3d(1.15, 0.85, 1);
                            transform: scale3d(1.15, 0.85, 1);
                  }
                  65% {
                    -webkit-transform: scale3d(0.95, 1.05, 1);
                            transform: scale3d(0.95, 1.05, 1);
                  }
                  75% {
                    -webkit-transform: scale3d(1.05, 0.95, 1);
                            transform: scale3d(1.05, 0.95, 1);
                  }
                  100% {
                    -webkit-transform: scale3d(1, 1, 1);
                            transform: scale3d(1, 1, 1);
                  }
                }

             @-webkit-keyframes scale {
                  0% {
                    -webkit-transform: scale(1.1);
                            transform: scale(1.1);
                    opacity: 0;
                  }
                  100% {
                    -webkit-transform: scale(1);
                            transform:scale(1);
                    opacity: 1; 
                  }
             }
            .slide-in-blurred-top {
                 -webkit-animation: slide-in-blurred-top 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;
                        animation: slide-in-blurred-top 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both;
            }
            @-webkit-keyframes slide-in-blurred-top {
                  0% {
                    -webkit-transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
                            transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
                    -webkit-transform-origin: 50% 0%;
                            transform-origin: 50% 0%;
                    -webkit-filter: blur(40px);
                            filter: blur(40px);
                    opacity: 0;
                  }
                  100% {
                    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
                            transform: translateY(0) scaleY(1) scaleX(1);
                    -webkit-transform-origin: 50% 50%;
                            transform-origin: 50% 50%;
                    -webkit-filter: blur(0);
                            filter: blur(0);
                    opacity: 1;
                  }
                }
                @keyframes slide-in-blurred-top {
                  0% {
                    -webkit-transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
                            transform: translateY(-1000px) scaleY(2.5) scaleX(0.2);
                    -webkit-transform-origin: 50% 0%;
                            transform-origin: 50% 0%;
                    -webkit-filter: blur(40px);
                            filter: blur(40px);
                    opacity: 0;
                  }
                  100% {
                    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
                            transform: translateY(0) scaleY(1) scaleX(1);
                    -webkit-transform-origin: 50% 50%;
                            transform-origin: 50% 50%;
                    -webkit-filter: blur(0);
                            filter: blur(0);
                    opacity: 1;
                  }
                }
                .roll-in-left {
                    -webkit-animation: roll-in-left 0.6s ease-out both;
                           animation: roll-in-left 0.6s ease-out both;
                }
                @-webkit-keyframes roll-in-left {
                  0% {
                    -webkit-transform: translateX(-800px) rotate(-540deg);
                            transform: translateX(-800px) rotate(-540deg);
                    opacity: 0;
                  }
                  100% {
                    -webkit-transform: translateX(0) rotate(8deg);
                            transform: translateX(0) rotate(8deg);
                    opacity: 1; 
                  }
                }
                @keyframes roll-in-left {
                  0% {
                    -webkit-transform: translateX(-800px) rotate(-540deg);
                            transform: translateX(-800px) rotate(-540deg);
                    opacity: 0;
                  }
                  100% {
                    -webkit-transform: translateX(0) rotate(8deg);
                            transform: translateX(0) rotate(8deg);
                    opacity: 1; 
                  }
                }
                
                
            .shake {
              /* Start the shake animation and make the animation last for 0.5 seconds */
              animation: shake 1.5s;
            
              /* When the animation is finished, start again */
              animation-iteration-count: infinite;
            }    
            @keyframes shake {
              0% { transform: translate(1px, 1px) rotate(0deg); }
              10% { transform: translate(-1px, -2px) rotate(-1deg); }
              20% { transform: translate(-3px, 0px) rotate(1deg); }
              30% { transform: translate(3px, 2px) rotate(0deg); }
              40% { transform: translate(1px, -1px) rotate(1deg); }
              50% { transform: translate(-1px, 2px) rotate(-1deg); }
              60% { transform: translate(-3px, 1px) rotate(0deg); }
              70% { translate(1px, 1px) rotate(0deg); }
              100% { transform: translate(1px, -2px) rotate(-1deg); }
            }
            
            .pulsate {
                 -webkit-animation: pulsate 2.5s ease-out;
                 -webkit-animation-iteration-count: infinite;
                 animation: pulsate 2.5s ease-out;
                 animation-iteration-count: infinite;
                  
             }
              .pulsate-2 {
                 -webkit-animation: pulsate-2 2.5s ease-out;
                 -webkit-animation-iteration-count: infinite;
                 animation: pulsate-2 2.5s ease-out;
                 animation-iteration-count: infinite;
                  
             }
             @-webkit-keyframes pulsate {
                 0% {
                     opacity: 0.8;
                     -webkit-transform: scale(1.0);
                     transform: scale(1.0);
                 }
                 50% {
                     opacity: 1.0;
                     -webkit-transform: scale(1.1);
                     transform: scale(1.1);
                 }
                 100% {
                     opacity: 0.8;
                     -webkit-transform: scale(1.0);
                     transform: scale(1.0);
                 }
               }
                @-webkit-keyframes pulsate-2 {
                 0% {
                     opacity: 0.8;
                     -webkit-transform: scale(1.0) rotate(5deg);
                     transform: scale(1.0) rotate(5deg);
                 }
                20% {
                     opacity: 1.0;
                     -webkit-transform: scale(1.1);
                     transform: scale(1.1);
                 }
                 100% {
                     opacity: 0.8;
                     -webkit-transform: scale(1.0) rotate(5deg);
                     transform: scale(1.0) rotate(5deg);
                 }
               }
               
               @media screen and (max-width:768px){
                .texts p{
                  font-size:80px;
                }
                .start-button {
                    width: 250px;
                    height: 250px;
                    font-size:60px;
                    outline:none;
                    border:5px solid #865887a8;
                    box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.35);
                    -webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.35);
                    -moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.35);
                    
                }
                .texts-2 p{
                     font-size:80px;
                     line-height:60px
                }
                .gift img{
                    width:200px
                }
                .mask2 img, .mask1 img{
                    width:80%!important;
                }
            }
            
             .mask1 {
                    -webkit-mask-image: url(/images/new-year-landing/1gift1.svg);
                        mask-image: url(/images/new-year-landing/1gift1.svg);
                            -webkit-mask-size:100%;
                        mask-size: 100%;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
            }
            
               .mask2 {
                    clip-path: polygon(5% 0%, 95% 0%, 100% 5%, 100% 95%, 95% 100%, 5% 100%, 0% 95%, 0% 5%);
            }
            
        `}</style>
      {step == 1 && (
        <div className={'h-screen bg-image-for-landing relative w-full  text-center  justify-between items-center flex flex-col py-40'}>
          {showModal && (
            <div className="modal w-full h-full transform-center flex justify-center">
              <div className="mb-10 w-300 h-full flex flex-col justify-center items-end">
                <p className="text-14  mb-5  text-white font-bolder self-start">Confirm your email</p>
                {error && <p className={'text-red font-bolder text-14 mb-5 -pl-20 self-start'}>{error}</p>}
                <Input onChange={e => setEmail(event.target.value)} type="text" name="email" bg="bg-white w-full rounded-8 self-stetch" />
                <button
                  onClick={() => {
                    checkValid(email);
                  }}
                  className={'bg-green rounded-5 px-30 py-5 text-white'}
                >
                  Send
                </button>
              </div>
            </div>
          )}
          <img src="https://weprodigi.com/uploads/images/new-year-2023/tree21.png" className={'absolute left-0 bottom-0 tree-1'} alt="tree" />
          <img src="https://weprodigi.com/uploads/images/new-year-2023/tree2.png" className={'absolute left-0 bottom-0 tree-2'} alt="tree" />
          <img src="https://weprodigi.com/uploads/images/new-year-2023/tree11.png" className={'absolute bottom-0 tree-3'} alt="tree" />
          <img src="https://weprodigi.com/uploads/images/new-year-2023/tree1.png" className={'absolute bottom-0 tree-4'} alt="tree" />
          <h1 className={'texts w-full'}>
            <p className={'w-full text-center slide-in-blurred-top'}>Lucky</p>
            <p className={'w-full text-center rotate roll-in-left  '}>Prodigist</p>
          </h1>
          {!showModal && (
            <button
              onClick={() => {
                setShowModal(true);
                myPriceAudio.play();
              }}
              className={'relative z-100 start-button'}
            >
              Start
            </button>
          )}
          <a href="/" className={'texts-link  text-center z-900 relative'}>
            <img src="https://weprodigi.com/uploads/images/new-year-2023/logo-dark.png" alt="logo-dark" />
          </a>
        </div>
      )}
      {step == 2 && (
        <div className="h-screen bg-image-for-landing relative w-full page-2  text-center  justify-start items-center flex flex-col py-50">
          <img src="https://weprodigi.com/uploads/images/new-year-2023/tree21.png" className={'absolute left-0 bottom-0 tree-1'} alt="tree" />
          <img src="https://weprodigi.com/uploads/images/new-year-2023/tree2.png" className={'absolute left-0 bottom-0 tree-2'} alt="tree" />
          <img src="https://weprodigi.com/uploads/images/new-year-2023/tree11.png" className={'absolute bottom-0 tree-3'} alt="tree" />
          <img src="https://weprodigi.com/uploads/images/new-year-2023/tree1.png" className={'absolute bottom-0 tree-4'} alt="tree" />
          {!error && (
            <>
              {!showGift && isWinner && (
                <div className={'texts-2 w-full'}>
                  <p className={'w-full text-center rotate-2 pulsate-2 '}>Winner</p>
                </div>
              )}
              {!showGift && !isWinner && (
                <div className={'texts-2 w-full'}>
                  <p className={'w-full text-center rotate-2 pulsate-2 '}>TRY AGAIN</p>
                </div>
              )}
              {showGift && (
                <div className={'texts-2 w-full'}>
                  <p className={'w-full text-center rotate-2 pulsate-2 '}>Try your luck</p>
                  <p className={'w-full text-center mt-20 pulsate'}>TODAY !</p>
                </div>
              )}
            </>
          )}

          {exists ? (
            <div className={'texts-2 h-full flex justify-center items-center'}>
              {error && <p className={'text-red font-bolder text-25 text-center mb-5   relative z-900  '}>{error}</p>}
            </div>
          ) : (
            <>
              {showGift && (
                <button onClick={() => getGift()} className={'relative gift z-100 mt-100 shake'}>
                  <img src="https://weprodigi.com/uploads/images/new-year-2023/gift-2.png" width={400} alt="gift-2" />
                </button>
              )}
              {!showGift && isWinner && (
                <div className={'mask1 relative mt-100'}>
                  <img src={imgUrl} alt="" className={'relative z-900 mx-auto'} />
                </div>
              )}
              {!showGift && !isWinner && (
                <div className={'mask2 relative mt-100'}>
                  <img src={imgUrl} alt="" className={'relative z-900 mx-auto'} />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};
export default NewYear2023;
